"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnce = useOnce;

var _react = require("react");

function useOnce(cbk) {
  return (0, _react.useEffect)(cbk, []);
}
//# sourceMappingURL=use-once.js.map